import { Navigate } from 'react-router-dom';
import { isoDay } from '../components/coach-hour-row.js';

/** /coach/lessons, the old one-day view: the Lessons tab on today (16 October). */
export function CoachTodayRedirect() {
  return <Navigate to={`/lessons?date=${isoDay(new Date())}`} replace />;
}
